/* eslint-disable @typescript-eslint/no-explicit-any */
import server from "api/server";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getStripePublishKey = createAsyncThunk(
  "getStripePublishKey",

  async () => {
    try {
      const { data } = await server.stripePayment.getPublishKey();
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const getStripeClientSecret = createAsyncThunk(
  "getStripeClientSecret",

  async (payload: any) => {
    try {
      const { data } = await server.stripePayment.getClientSecret(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const postTransactionDetails = createAsyncThunk(
  "postTransactionDetails",

  async (payload: any) => {
    try {
      const { data } = await server.stripePayment.postTransactionDetails(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const deletePaymentIntent = createAsyncThunk(
  "deletePaymentIntent",

  async (payload: any) => {
    try {
      const { data } = await server.stripePayment.deletePaymentIntent(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);
export const getGeneratedDatasetURLS = createAsyncThunk(
  "getGeneratedURL",

  async (payload: any) => {
    try {
      const { data } = await server.stripePayment.getGeneratedDatasetURL(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const generateDataSet = createAsyncThunk(
  "generatePurcaseDataset",

  async (payload: any) => {
    try {
      const { data } = await server.stripePayment.generateDataSet(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);
